export default "__VITE_ASSET__Mc2DRVm1__"